(() => {
  const mysteryDiscountLabel = 'mystery discount';

  const removeMysteryDiscountLauncher = () => {
    document.querySelectorAll('button, [role="button"]').forEach((element) => {
      const label = [element.getAttribute('aria-label'), element.getAttribute('title'), element.innerText]
        .filter(Boolean)
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      if (label === mysteryDiscountLabel) {
        element.hidden = true;
      }
    });
  };

  removeMysteryDiscountLauncher();

  new MutationObserver(removeMysteryDiscountLauncher).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
